module.exports = __webpack_public_path__ + "img/c.60b0240c.jpg";